export default __webpack_public_path__ + "static/media/HtmlDEv.bbc777d5.PNG";